import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import AdScriptLoader from '../components/AdScriptLoader';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Ad Scripts - Header Position 
      <AdScriptLoader page="landing" position="header" user={null} className="w-full" />*/}
      
      {/* Warning Banner */}
      <div className="bg-yellow-400 text-gray-900 px-4 py-3 text-center">
        <span className="font-medium">⚠️ Warning: Please do not share your personal details like contact number, email, pictures with anybody</span>
      </div>

      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="container mx-auto px-4 py-3 md:py-4">
          {/* Mobile: Stack vertically, Desktop: Side by side */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            {/* Logo */}
            <div className="flex items-center justify-center sm:justify-start gap-2">
              <img src="/logo.png" alt="ChatHub India" className="h-8 sm:h-10 w-auto" />
              <span className="text-xl sm:text-2xl font-bold text-gray-900">ChatHub</span>
            </div>
            {/* Navigation Buttons */}
            <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap">
              <button
                onClick={() => navigate('/auth')}
                className="px-3 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base text-gray-700 hover:text-gray-900 font-medium"
              >
                Guest Login
              </button>
              <button
                onClick={() => navigate('/auth')}
                className="px-3 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base text-blue-600 hover:text-blue-700 font-medium"
              >
                User Login
              </button>
              <button
                onClick={() => navigate('/auth')}
                className="px-4 py-1.5 sm:px-6 sm:py-2 text-sm sm:text-base bg-gray-900 text-white rounded-lg hover:bg-gray-800 font-medium"
              >
                Register
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <main className="flex-1 container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Real-time Conversations, <span className="text-blue-600">Anywhere</span>
          </h1>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Join thousands of users in real-time chat rooms. Connect with friends, share media,
            and be part of a vibrant community. Now play Ludo with in-game voice calling.
          </p>
          <div className="flex gap-4 justify-center">
            <button
              onClick={() => navigate('/auth')}
              className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold text-lg"
            >
              Get Started Free
            </button>
            <button
              onClick={() => navigate('/auth')}
              className="px-8 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 font-semibold text-lg"
            >
              Try as Guest
            </button>
          </div>
        </div>

        {/* Features */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Real-time Messaging</h3>
            <p className="text-gray-600">
              Instant message delivery with WebSocket technology. Chat in real-time with friends and groups.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Public & Private Rooms</h3>
            <p className="text-gray-600">
              Create your own rooms or join existing ones. Control who can join with invite-only options.
            </p>
          </div>

          <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Secure & Moderated</h3>
            <p className="text-gray-600">
              Advanced moderation tools, user roles, and privacy controls keep the community safe.
            </p>
          </div>
        </div>

        {/* New: Ludo + VoIP Features */}
        <div className="bg-white rounded-2xl p-8 sm:p-10 shadow-xl mb-16">
          <div className="flex items-center justify-between gap-4 mb-8 flex-wrap">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">New: Ludo + Voice Experience</h2>
            <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-sm font-semibold">Just Added</span>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="rounded-xl border border-gray-200 p-5 bg-gradient-to-br from-blue-50 to-indigo-50">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Multiplayer Ludo (2P / 4P)</h3>
              <p className="text-gray-600">Create a match, invite friends with token/link, and play in real time.</p>
            </div>

            <div className="rounded-xl border border-gray-200 p-5 bg-gradient-to-br from-emerald-50 to-teal-50">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">In-Game VoIP Calling</h3>
              <p className="text-gray-600">Start and join Ludo group calls without leaving the board.</p>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <button
              onClick={() => navigate('/auth')}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold"
            >
              Start Ludo Match
            </button>
            <button
              onClick={() => navigate('/auth')}
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 font-semibold"
            >
              Join with Invite
            </button>
          </div>
        </div>

        {/* Why Choose ChatHub */}
        <div className="bg-white rounded-2xl p-12 shadow-xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Why Choose ChatHub?</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">✓</div>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">100% Free to Use</h4>
                <p className="text-gray-600">No hidden fees. Create unlimited rooms and connect with unlimited users.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">✓</div>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Indian Community</h4>
                <p className="text-gray-600">Connect with Telugu, Andhra, Telangana, and pan-India users in regional chat rooms.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">✓</div>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Private Messaging</h4>
                <p className="text-gray-600">Send direct messages to friends with full privacy and custom backgrounds.</p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold">✓</div>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-1">Media Sharing</h4>
                <p className="text-gray-600">Share images, GIFs, and videos. Express yourself with emojis and GIPHY integration.</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer user={null} page="landing" />
    </div>
  );
};

export default LandingPage;
